import React from 'react';

export const TermsAndConditionsAndPrivacy = () => {
    return (
        <div
            data-testid="terms-conditions"
            style={{
                maxWidth: '90%',
                margin: '0 auto',
                padding: '2rem',
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: 15,
                lineHeight: '160%',
                letterSpacing: 0,
                color: '#4C525D',
            }}
        >
            <h1
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 400,
                    fontSize: 35,
                    lineHeight: '56px',
                    letterSpacing: 0,
                    color: '#071424',
                    padding: '16px 0',
                }}
            >
                Terms and Conditions
            </h1>
            <p style={{ fontWeight: 600 }}>Effective Date: February 20th, 2025</p>
            <p>
                These terms and conditions and all other legal documents incorporated by reference (collectively, the
                "Terms") are a legal contract between “you,” on behalf of yourself and your employer, and Subaru of
                America, Inc. (collectively “SOA,” “we,” “our,” or “us”)  with respect to access to and use of the
                internal website as “TechShare™” found at https://subarutechshare.com/ (including the TechShare™ mobile
                application found on Google Play Store and Apple AppStore), as linked and offered by us, and any and all
                materials, documents, software, extracts, all other SOA owned or controlled websites, and software that
                we provide to you for download in your devices (all of these collectively, the “Site”).
            </p>
            <p>
                <b>IMPORTANT – PLEASE READ CAREFULLY – THESE TERMS GOVERN YOUR USE OF THIS SITE.</b> BY ACCESSING,
                VIEWING, BROWSING, DOWNLOADING, VISITING OR USING THIS SITE YOU ACCEPT AND AGREE TO BE BOUND, WITHOUT
                LIMITATION OR QUALIFICATION, BY THESE TERMS. IF YOU DO NOT ACCEPT ANY OF THESE TERMS, YOU MAY NOT USE
                THIS SITE. SOA MAY, IN ITS SOLE DISCRETION, MODIFY OR REVISE THESE TERMS AT ANY TIME BY UPDATING THIS
                DOCUMENT. YOU ARE BOUND BY ANY SUCH MODIFICATION OR REVISION AND SHOULD THEREFORE VISIT THIS PAGE
                PERIODICALLY TO REVIEW THESE TERMS. IF THESE TERMS ARE NOT ACCEPTABLE TO YOU, YOUR SOLE REMEDY AND
                RECOURSE IS TO DISCONTINUE USE OF THIS SITE.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Authorized Use
            </h2>
            <p>
                Subject to these Terms, we authorize you to upload, view and download the information and other
                materials at or through this Site solely for your use in connection with your obligations set forth in
                the agreement between you and SOA and you will only use this site as permitted pursuant to such
                agreement and in furtherance of the sale and service of Subaru branded vehicles, products, and services,
                provided that you retain all copyright and other proprietary notices contained in the original materials
                on any copies of the materials. You may not, without the prior written permission of SOA, “mirror” any
                material contained on, or accessed through, this Site on any other server.
            </p>
            <p>
                The Site may allow certain registered users to access additional services, which are subject to
                additional terms applicable to such portal(s) or services, and which are hereby incorporated by
                reference if you access and/or use such additional services (“Additional Terms”). In the event of any
                conflict between these Terms and the Additional Terms, the Additional Terms will prevail. In cases where
                the Additional Terms do not address specific provisions that are included in these Terms, these Terms
                will apply, supplementing such Additional Terms.
            </p>
            <p>
                We reserve the right to terminate or modify the Site in whole or in part, in any manner in our sole
                discretion, without notice. We will not be liable if, for any reason, all or any part of the Site is
                unavailable at any time or for any period. From time to time, we may restrict access to all or part of
                the Site to a subset of permitted users. You are solely responsible for making all arrangements
                necessary for you to access the Site.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Submissions
            </h2>
            <p>
                You are responsible for all information, materials, documents, and other content (collectively,
                “Content”) that you submit to the Site. You shall be solely liable for any damage resulting from any
                infringement of copyrights, trademarks, proprietary rights, violation of contract, privacy or publicity
                rights or any other harm resulting from any Content you submit.  You agree to pay for all royalties,
                fees, damages and any other monies owing any person by reason of any Content submitted by you to or
                through the Site. When you submit Content to the Site, you simultaneously grant SOA an irrevocable,
                worldwide, royalty free license to publish, display, modify, distribute and syndicate the Content
                worldwide.
            </p>
            <p>
                You represent and warrant that (i) you have reviewed and validated all Content submitted to the Site and
                that the Content is truthful, accurate, and timely; (ii) you have obtained all necessary consents to
                grant SOA the rights and licenses to the Content as set forth above; (iii) any executed documents you
                upload as part of the Content are signed by duly authorized representatives of the parties to such
                document; (iv) you have and shall comply with all applicable law in connection with your use of and your
                submission of any Content to the Site; (i) you will not sell, license, or transfer to any party other
                than SOA any information obtained through the Site; (ii) you have the right and authority to enter into
                these Terms on behalf of yourself and your employer, and that by entering into or executing your
                obligations under these Terms, you will not be in breach or violation of the terms of any agreement with
                or obligation to any third party.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Ownership
            </h2>
            <p>
                You acknowledge and agree that the Materials displayed on or through this Site, including without
                limitation all information, data, text, software, photographs, graphics, video, or other materials (the
                “Materials”) is copyrighted by us or our licensors under United States of America and international
                copyright laws. The Materials may not be copied, modified, reproduced, republished, posted, transmitted,
                sold, offered for sale, or redistributed in any way without our prior written permission. You must abide
                by all copyright notices, information, or restrictions contained in or attached to any Materials,
                including the Site itself. Copyright © 2024 Subaru of America, Inc. All rights reserved.
            </p>
            <p>
                The Subaru logo, TechShare™ logo and certain other words and logos displayed on this Site and which may
                or may not be designated on this Site by a “TM” “®” “SM” or other similar designation, constitute
                trademarks, trade names, or service marks (collectively, “Marks”) of SOA or other entities. You are not
                authorized to use any such Marks without our prior written consent. Ownership of all such Marks and the
                goodwill associated therewith remains with us or our respective licensors.
            </p>
            <p>
                Nothing contained on this Site should be construed as granting, by implication, estoppel, or otherwise,
                any license or right to use this Site or any information displayed on this Site, through the use of
                framing, deep linking or otherwise, except: (a) as expressly permitted by these Terms; or (b) with prior
                written permission from us.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Disclaimers
            </h2>
            <p>
                YOU EXPRESSLY AGREE THAT YOUR USE OF THIS SITE AND THE MATERIALS SHALL BE AT YOUR SOLE DISCRETION AND
                RISK. THIS SITE AND THE MATERIALS ARE PROVIDED ON AN “AS IS” AND “AS-AVAILABLE” BASIS WITHOUT ANY
                WARRANTIES OF ANY KIND. TO THE FULLEST EXTENT PERMITTED BY LAW, SOA DISCLAIMS ALL WARRANTIES, INCLUDING,
                BUT NOT LIMITED TO, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                NON-INFRINGEMENT OF PROPRIETARY OR THIRDPARTY RIGHTS, QUIET ENJOYMENT, SYSTEM INTEGRATION AND/OR DATA
                ACCURACY.  NO WARRANTY IS MADE BY SOA ON THE BASIS OF TRADE USAGE OR COURSE OF DEALING.  SOA MAKES NO
                WARRANTIES ABOUT THE ACCURACY, RELIABILITY, COMPLETENESS, OR TIMELINESS OF THIS SITE OR THE MATERIALS OR
                ABOUT THE RESULTS TO BE OBTAINED FROM USING THIS SITE OR THE MATERIALS.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Limitation of Liability
            </h2>
            <p>
                IN NO EVENT SHALL SOA OR ITS AFFILIATES, AFFILIATED RETAILERS, INDEPENDENT DISTRIBUTORS, EMPLOYEES,
                OFFICERS, DIRECTORS, AGENTS OR LICENSORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, OR
                CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE THIS SITE OR THE CONTENT
                INCLUDING, BUT NOT LIMITED TO, RELIANCE BY A USER ON ANY INFORMATION OBTAINED AT THIS SITE.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Prohibited Conduct
            </h2>
            <ul>
                <li>
                    Defame, abuse, harass, stalk, threaten, or otherwise violate the legal rights (such as rights of
                    privacy and publicity) of others.
                </li>
                <li>Use racially, ethnically, hateful, misogynist, or otherwise offensive language.</li>
                <li>Discuss or incite illegal activity.</li>
                <li>Use explicit/obscene language or solicit/post sexually explicit images (actual or simulated).</li>
                <li>Post anything that exploits children or minors or that depicts cruelty to animals.</li>
                <li>Post any copyrighted or trademarked materials without the express permission from the owner.</li>
                <li>
                    Disseminate any unsolicited or unauthorized advertising, promotional materials, 'junk mail', 'spam',
                    'chain letters', 'pyramid schemes', or any other form of such solicitation.
                </li>
                <li>Use any robot, spider, scraper or other automated means to access the Site.</li>
                <li>
                    Take any action that imposes an unreasonable or disproportionately large load on our infrastructure.
                </li>
                <li>
                    Alter anything posted by others on the Site (except for the areas designated for your user role to
                    make changes through the site’s permission rules).
                </li>
                <li>Post or submit anything clearly false or misleading.</li>
                <li>Post or submit anything unrelated to our business, products or services.</li>
                <li>
                    Post or submit anything contrary to our public image, goodwill or reputation, provided that the
                    foregoing will not apply to you if applicable law prohibits such limitations and restrictions.
                </li>
                <li>
                    Save, download, copy, print or share any of the resources available to you in the site in partial,
                    full or bulk, for any reason other than to support SOA’s business cause.
                </li>
                <li>
                    Post or submit incomplete or falsified information while seeking technical assistance, repair
                    authorization, etc. from SOA staff.
                </li>
            </ul>
            <p>
                This list of prohibitions provides examples and is not complete or exclusive. SOA reserves the right
                terminate access to and/or use of the Site with or without cause and with or without notice, for any
                reason or no reason, or for any action that SOA determines is inappropriate or disruptive to the Site or
                to any other user of the Site. SOA may report to law enforcement authorities any actions that may be
                illegal, and any reports it receives of such conduct.  When legally required or at SOA’s discretion, SOA
                will cooperate with law enforcement agencies in any investigation of alleged illegal activity on the
                Site or on the Internet.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Indemnity
            </h2>
            <p>
                To the extent permitted by applicable law, you agree to defend, indemnify, and hold harmless SOA and its
                parent company, as well as their respective its officers, directors, employees, and agents, from and
                against any claims, actions or demands, including without limitation reasonable legal and accounting
                fees, alleging or resulting from your use of this Site or the Materials or the use of this Site by any
                person using your user name, password, and/or single-sign-on (including without limitation, any Content
                submitted using your username) violates any applicable law or regulation, or the copyrights, trademark
                rights or other rights of any third-party, or your breach of any representations, warranties, covenants
                or obligations contained in these Terms.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Links to Other Sites
            </h2>
            <p>
                This Site may provide links to third-party websites or resources and contain third-party
                advertisements.   We may also offer certain services provided by our business partners through this
                Site.  You agree and understand that such third-party websites or resources are subject to their own
                privacy policies and terms of use, that you are subject to those legal terms, and that we have no
                control over such websites and resources. You acknowledge and agree that we are not responsible for the
                availability of such websites or resources, and do not endorse and are not responsible or liable for any
                content, advertising, products, or other materials on or available from such websites or resources. You
                further acknowledge and agree that we shall not be responsible or liable, directly or indirectly, for
                any damage or loss caused or alleged to be caused by or in connection with the use of or inability to
                use (i) any sites or resources that this Site provides links to or that provide links to this Site, or
                (ii) any content, goods, or services available on or through any such sites or resources. We take no
                responsibility for third party advertisements which are posted on this Site, nor do we take any
                responsibility for the goods or services provided by its advertisers. Your dealings with, or
                participation in promotions of, any third-party advertisers or providers of goods or services found on
                or through this Site and any terms, conditions, warranties, or representations associated with such
                dealings, are solely between you and such third-party advertiser or provider.
            </p>
            <p>
                In no event shall any reference to any third party or third-party product or service be construed as our
                approval or endorsement of that third party or of any product or service provided by a third party.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                General
            </h2>
            <p>
                These Terms shall be governed by and construed in accordance with the laws of the State of New Jersey,
                USA, excluding its conflicts of laws principles. Foreign laws do not apply.  The United Nations on
                Contracts for the International Sale of Goods and any laws based on the Uniform Computer Information
                Transactions Act (UCITA) shall not apply to these Terms. If any dispute relating in any way to these
                Terms or your use of this Site shall be submitted to confidential arbitration in New Jersey, USA, except
                that, to the extent you have in any manner violated or threatened to violate our intellectual property
                rights, we may seek injunctive or other appropriate relief in any state or federal court in New Jersey,
                USA and you consent to exclusive jurisdiction and venue in such courts. Arbitration under these Terms
                shall be conducted under the rules then prevailing of the American Arbitration Association. The
                arbitrator’s award shall be binding and may be entered as a judgment in any court of competent
                jurisdiction. To the fullest extent permitted by applicable law, no arbitration under these Terms shall
                be joined to an arbitration involving any other party subject to these Terms, whether through class
                arbitration proceedings or otherwise.
            </p>
            <p>
                The failure to require performance of any provision shall not affect our right to require performance at
                any time thereafter, nor shall a waiver of any breach or default of these Terms constitute a waiver of
                any subsequent breach or default or a waiver of the provision itself. If any portion of these Terms is
                found to be unenforceable, such portion will be modified to reflect the parties’ intention and only to
                the extent necessary to make it enforceable, and the remaining provisions of these Terms will remain in
                full force and effect. These Terms together with any Additional Terms, policies and any other legal
                documents incorporated by reference constitute the entire and exclusive understanding and agreement
                between you and us regarding this subject matter and supersede any and all prior or contemporaneous
                agreements or understandings, written and oral.
            </p>
            <hr />
        </div>
    );
};
